import React from "react";
import { Button } from "../../../components/common";

type FeedTab = "posts" | "articles";

interface FeedActionsProps {
  activeTab: FeedTab;
  onTabChange: (tab: FeedTab) => void;
}

const Actions = ({ activeTab, onTabChange }: FeedActionsProps) => {
  return (
    <div className="custom-tab-wrapper">
      <div className="custom-tab-left">
        <ul className="tab-menu company-tabs">
          <li>
            <Button
              className={activeTab === "posts" ? "active" : ""}
              onClick={() => onTabChange("posts")}
            >
              Posts
            </Button>
          </li>
          <li>
            <Button
              className={activeTab === "articles" ? "active" : ""}
              onClick={() => onTabChange("articles")}
            >
              Articles
            </Button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Actions;
